import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsPlaidInfoMessageVisibility } from '../../state/actions';
import { Alert } from '../../../CommonComponents/OPL/Alert/Alert';
import { selectIsPlaidInfoMessageVisible } from '../../state/selector';
import { MarginProps } from '../../../theme/styledProps';

interface Props extends MarginProps {}

export const PlaidLinkInfoAlert: React.FC<Props> = props => {
  const dispatch = useDispatch();

  const isVisible = useSelector(selectIsPlaidInfoMessageVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <Alert
      message="Your institution has been successfully linked. It may take up to 24 hours for your accounts and transactions to appear in the portal."
      title="Account Linked Successfully"
      variant="info"
      onRequestClose={() => {
        dispatch(setIsPlaidInfoMessageVisibility(false));
      }}
      {...props}
    />
  );
};
